export default {
  DASHBOARD : "DASHBOARD",
  STUDIO : "STUDIO"
}



// WEBPACK FOOTER //
// ./src/core/constants/belongingComponent.js